import { useCallback, useEffect, useState } from 'react';
import { probeEmbedUrl } from './probeEmbedUrl';

/**
 * @returns {{ status: 'idle'|'checking'|'ready'|'unavailable', retry: () => void, retryKey: number }}
 */
export function useEmbedReachability(url, { enabled = true, timeoutMs = 4000 } = {}) {
  const [status, setStatus] = useState(enabled && url ? 'checking' : 'idle');
  const [retryKey, setRetryKey] = useState(0);

  const retry = useCallback(() => setRetryKey((k) => k + 1), []);

  useEffect(() => {
    if (!enabled || !url) {
      setStatus('idle');
      return undefined;
    }
    let cancelled = false;
    setStatus('checking');
    (async () => {
      const ok = await probeEmbedUrl(url, timeoutMs);
      if (!cancelled) setStatus(ok ? 'ready' : 'unavailable');
    })();
    return () => {
      cancelled = true;
    };
  }, [url, enabled, timeoutMs, retryKey]);

  return { status, retry, retryKey };
}
